export default __webpack_public_path__ + "static/media/bnr12.93064d87.jpg";